/**
 * Enable Bootstrap 5 dropdown toggle for mobile navigation.
 * Applies only on touch devices (no hover).
 * @package spx_inadeicke
 */
/**
 * Mobile dropdown toggle for Bootstrap 5 navigation.
 * Only active on touch devices (no hover).
 * @package spx_inadeicke
 */
document.addEventListener('DOMContentLoaded', function () {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        const closeAllDropdowns = (exceptMenu = null) => {
            document.querySelectorAll('.navbar .dropdown-menu.show').forEach(menu => {
                if (menu !== exceptMenu) {
                    menu.classList.remove('show');
                    const toggle = menu.parentElement.querySelector('[data-bs-toggle]');
                    if (toggle) toggle.setAttribute('aria-expanded', 'false');
                }
            });
        };

        document.querySelectorAll('.navbar .dropdown > a.nav-link').forEach(parentLink => {
            let tappedOnce = false;
            parentLink.addEventListener('click', function (e) {
                const dropdown = parentLink.parentElement;
                const menu = dropdown.querySelector('.dropdown-menu');
                const isOpen = menu && menu.classList.contains('show');

                if (!isOpen) {
                    // First tap: open dropdown only
                    e.preventDefault();
                    closeAllDropdowns(menu);
                    if (menu) {
                        menu.classList.add('show');
                        parentLink.setAttribute('aria-expanded', 'true');
                    }
                    tappedOnce = true;
                } else {
                    // Second tap: go to link
                    tappedOnce = false;
                    // Let default action happen (navigate)
                }
            });
        });

        document.addEventListener('click', function (e) {
            if (!e.target.closest('.navbar .dropdown')) {
                closeAllDropdowns();
            }
        });
    }
});
